export type ImportedContact = {
  name: string;
  phone: string;
  email: string;
};

function clean(value: unknown): string {
  return String(value ?? "").trim();
}

function unescapeVCard(value: string): string {
  return value
    .replace(/\\n/gi, " ")
    .replace(/\\,/g, ",")
    .replace(/\\;/g, ";")
    .replace(/\\\\/g, "\\")
    .trim();
}

export function parseVCardContacts(text: string): ImportedContact[] {
  const unfolded = text.replace(/\r?\n[ \t]/g, "");
  return unfolded
    .split(/END:VCARD/i)
    .map(block => {
      const lines = block.split(/\r?\n/);
      const fullName = lines.find(line => /^FN[;:]/i.test(line));
      const structuredName = lines.find(line => /^N[;:]/i.test(line));
      const phone = lines.find(line => /^TEL[;:]/i.test(line));
      const email = lines.find(line => /^EMAIL[;:]/i.test(line));
      let name = fullName ? fullName.slice(fullName.indexOf(":") + 1) : "";
      if (!name && structuredName) {
        const parts = structuredName.slice(structuredName.indexOf(":") + 1).split(";");
        name = [parts[1], parts[0]].filter(Boolean).join(" ");
      }
      return {
        name: unescapeVCard(name),
        phone: unescapeVCard(phone?.slice((phone?.indexOf(":") ?? -1) + 1) ?? ""),
        email: unescapeVCard(email?.slice((email?.indexOf(":") ?? -1) + 1) ?? ""),
      };
    })
    .filter(contact => contact.name && (contact.phone || contact.email));
}

export function mapContactRows(rows: Record<string, unknown>[]): ImportedContact[] {
  return rows.map(row => {
    const entries = Object.entries(row);
    const find = (...names: string[]) => {
      const entry = entries.find(([key]) => names.includes(key.toLowerCase().trim()));
      return clean(entry?.[1]);
    };
    const firstName = find("first name", "firstname", "given name");
    const lastName = find("last name", "lastname", "family name");
    return {
      name: find("name", "full name", "fullname") || [firstName, lastName].filter(Boolean).join(" "),
      phone: find("phone", "phone number", "mobile", "mobile phone", "telephone", "tel"),
      email: find("email", "email address", "e-mail"),
    };
  }).filter(contact => contact.name && (contact.phone || contact.email));
}